// Google Ads (AW-18343200322) — Consent Mode v2 + conversioni per clic reale.
// NB: sostituire i LABEL con le etichette conversione reali da Google Ads
// (Obiettivi > Conversioni > [azione] > Etichetta conversione). Finché contengono
// "REPLACE_", l'evento NON viene inviato (evita conversioni verso label non valide).
const ADS_ID = "AW-18343200322";

const CONVERSIONS = {
  whatsapp: `${ADS_ID}/REPLACE_WHATSAPP_LABEL`,
  call: `${ADS_ID}/REPLACE_CALL_LABEL`,
};

// Aggiorna Google Consent Mode v2 in base alle scelte del banner cookie.
// ad_personalization resta sempre "denied": nessun remarketing / pubblico personalizzato.
export function updateAdsConsent(consent) {
  try {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    window.gtag("consent", "update", {
      analytics_storage: consent && consent.statistiche ? "granted" : "denied",
      ad_storage: consent && consent.marketing ? "granted" : "denied",
      ad_user_data: consent && consent.marketing ? "granted" : "denied",
      ad_personalization: "denied",
    });
  } catch (e) {}
}

// Invia una conversione SOLO su clic reale (WhatsApp o Chiama), mai su page view.
export function trackConversion(type) {
  try {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    const sendTo = CONVERSIONS[type];
    if (!sendTo || sendTo.includes("REPLACE_")) return;
    window.gtag("event", "conversion", { send_to: sendTo });
  } catch (e) {}
}
